<template>
  <v-app class="grey lighten-3">
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Dasher Basic Info</span>
              </div>

              <v-spacer></v-spacer>

              <v-btn color="blue darken-2" small dark @click="back"
                >Back
              </v-btn>
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="indexData.dasherInfo"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <v-layout class="v-navigation-drawer__content">
                      <v-flex xs12 sm12 md12>
                        <tr style="border: 1px #ddd solid">
                          <td width="30%">ID</td>
                          <td>:</td>
                          <td width="70%" class="text-xs-left">
                            {{ props.item.id }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td width="30%">Name</td>
                          <td>:</td>
                          <td width="70%" class="text-xs-left">
                            {{ props.item.first_name }} {{ props.item.middle_name }} {{ props.item.last_name }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Team Code</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            N/A
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Rank Current</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.rank_id }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Last Activity date</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.last_activity_date }}
                          </td>
                        </tr>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
              </template>
            </v-card-text>
          </v-card>

          <v-card-title class="project">
            <div class="white--text headline">
              <span>Dasher Cash Out Details Report</span>
            </div>
          </v-card-title>

          <v-spacer></v-spacer>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              align="center"
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div v-if="isLoaded">
            <template>
              <v-flex>
                <v-data-table
                  :headers="headers"
                  :items="indexData.dasherCashOutDetails"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.created_at }}</td>
                    <td>{{ props.item.transaction_date }}</td>
                    <td>{{ props.item.transaction_id }}</td>
                    <td>{{ props.item.withdraw_status_id }}</td>
                    <td>{{ props.item.wallet_type }}</td>
                    <td>{{ props.item.transaction_id }}</td>
                    <td>{{ props.item.amount_coin }}</td>
                    <td>{{ props.item.remaining_amount }}</td>
                    <td>{{ getTaka(props.item.amount_coin) }}</td>
                    <td>{{ getTaka(props.item.remaining_amount) }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </template>
          </div>
          <!-- end location -->
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../../../router";

export default {
  data: () => ({
    apiUrl: "dasher-cash-out-report",
    editedIndex: -1,
    dialog: false,
    search: "",
    projectId: "",
    transaction_status_id: "",
    paymentPercentage: "",
    projectStatus: {
      status_name: null,
      status_id: null,
    },
    paymentStatus: {
      payment_status_name: null,
      payment_status_id: null,
    },
    projectTypeId: null,
    headers: [
     
      { text: "Date of Request", value: "created_at" },
      { text: "Date of Transaction", value: "transaction_date" },
      { text: "Transaction ID", value: "transaction_id" },
      { text: "Transaction Status", value: "withdraw_status_id" },
      { text: "Cash Out Details", value: "wallet_type" },
      { text: "Reference", value: "transaction_id" },
      { text: "Coins Cash Out", value: "amount_coin" },
      { text: "Coins Balance", value: "remaining_amount" },
      { text: "Taka Cash Out", value: "amount_coin" },
      { text: "Taka Balance", value: "remaining_amount" },
    ],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.dasherCashOutDetails) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      var user_id = localStorage.getItem("dasher_id");
      //  console.log(user_id);
      this.$store.dispatch("getDasherReportDetails", [
        user_id,
        "dasher-cash-out-report",
        "/dasher-summary-report",
        "",
      ]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
getTaka: function(coins){
return (coins/10)
},
    close() {
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    back() {
      router.push("/dasher-summary-report");
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.no-upercase {
  text-transform: unset !important;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
::v-deep ::-webkit-scrollbar {
  width: 0;
}
</style>
